const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/accounts.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import type { CreateAccountRequest } from "@/api/types.gen";
export const Route = createFileRoute("/_app/accounts")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface CreateAccountForm {
  full_name: string;
  email: string;
  password: string;
  confirm_password: string;
  role: "client" | "designer" | "manager";
}